module.exports = __webpack_public_path__ + "static/img/duihuan.5cf87413.png";